import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use(
  VTooltip,
  {
    defaultClass: 'tooltip',
    defaultTargetClass: 'has-tip',
    defaultTemplate: '<span class="tooltip" role="tooltip"><span class="tooltip-inner"></span><span class="nub"></span></span>'
  }
)



// WEBPACK FOOTER //
// ./src/plugins/v-tooltip.js